export const PermittedNavItems = (permissions, navItems) => {
  const updateHidden = item => {
    /*
     * An item that declares its own gate (`requiresFeature`) is NOT subject to
     * the RBAC screen check.
     *
     * The check below passes only when the user holds a permission whose
     * screenName matches the item's navTitle. There is no ASSESSMENTS screen in
     * the CORPORATE journey at all — the journey has DASHBOARD, ROLES, USERS,
     * REPORTS, SETTINGS, ACTIVITY LOG, INTERVIEWER DASHBOARD and JOBROLES — so
     * the Assessment item was hidden for EVERY corporate user no matter what
     * they had subscribed to. That is why it never appeared.
     *
     * Its gate is the subscription (corporates.accessLevel, surfaced as the
     * ASSESSMENT feature flag), which Nav applies separately. Two gates where
     * one of them can never open is not defence in depth, it is a dead item.
     *
     * This does not remove the option of per-user control later: add an
     * ASSESSMENTS screen row for the CORPORATE journey, drop `requiresFeature`
     * from the nav item, and the check below starts applying again.
     */
    if (item?.requiresFeature) {
      return { ...item, hidden: false }
    }
    const hidden = !permissions.some(permission => {
      if (permission.subEvents != null) {
        return (
          permission?.subEvents?.events?.screens?.screenName.toUpperCase() ==
            item?.navTitle?.toUpperCase() ||
          item?.navTitle === 'Global' ||
          item?.navTitle === 'Dashboard' ||
          item?.navTitle === 'Mandates' ||
          item?.navTitle === 'Corporate Dashboard' ||
          item?.navTitle === 'Corporate Dashboard 2'
        )
      } else {
        return (
          permission?.events?.screens?.screenName.toUpperCase() ==
            item?.navTitle?.toUpperCase() ||
          item?.navTitle === 'Global' ||
          item?.navTitle === 'Dashboard' ||
          item?.navTitle === 'Mandates' ||
          item?.navTitle === 'Corporate Dashboard' ||
          item?.navTitle === 'Corporate Dashboard 2'
        )
      }
    })
    return { ...item, hidden }
  }
  const updateHiddenSubMenu = item => {
    const hidden = !permissions.some(permission => {
      if (permission?.subEvents != null) {
        return (
          permission?.subEvents?.events?.eventName.toUpperCase() ==
          item?.navTitle?.toUpperCase()
        )
      } else {
        return (
          permission?.events?.eventName.toUpperCase() ==
          item?.navTitle?.toUpperCase()
        )
      }
    })
    return { ...item, hidden }
  }

  const updateMenuItems = items => {
    return items.map(item => {
      let updatedItem
      if (item.externalMenu) {
        updatedItem = {
          ...item,
          externalMenu: updateMenuItems(item.externalMenu),
        }
        const hidden = updatedItem?.externalMenu?.every(item => item.hidden)
        updatedItem = {
          ...item,
          hidden,
          externalMenu: updatedItem?.externalMenu,
        }
      } else {
        updatedItem = item?.path?.includes('/reports')
          ? updateHiddenSubMenu(item)
          : updateHidden(item)
      }

      return updatedItem
    })
  }

  return updateMenuItems(navItems)
}

const Eventcruds = [
  'NEW ROLE',
  'RANKING CONFIG',
  'VIEW',
  'SAVE CHANGES',
  'ADD USER',
  'EDIT',
  'ACTIONS',
  'ROLES',
  'ACTIVE ROLES',
  'DRIVES',
  'ONGOING DRIVES',
  'EDIT & UPDATE',
  'CLOSE APPLICATION',
  'DUPLICATE',
  'DELETE',
  'DRIVE INFO',
  'INACTIVE',
  'FRESHERS',
  'TOTAL APPLICATIONS',
  'EXPERIENCED CANDIDATES',
  'ACTIVE/INACTIVE',
]

export const permittedCruds = (permissions, screenName) =>
  !permissions?.length
    ? Eventcruds
    : Eventcruds?.filter(cruds => {
        return permissions.find(permission => {
          if (
            permission?.subEvents != null &&
            permission?.subEvents?.events?.screens?.screenName?.toLocaleUpperCase() ===
              screenName?.toUpperCase()
          ) {
            return (
              permission?.subEvents?.events?.eventName?.toLocaleUpperCase() ===
              cruds.toUpperCase()
            )
          } else if (
            permission?.events?.screens?.screenName?.toLocaleUpperCase() ===
            screenName?.toUpperCase()
          ) {
            return (
              permission?.events?.eventName?.toLocaleUpperCase() ===
              cruds?.toUpperCase()
            )
          }
        })
      })

export const permittedEventCruds = (permissions, screenName) => {
  const foundPermissions = permissions?.filter(permission => {
    return Eventcruds?.find(cruds => {
      if (
        permission?.screens?.screenName?.toLocaleUpperCase() ===
        screenName?.toUpperCase()
      ) {
        return (
          permission?.events?.eventName?.toLocaleUpperCase() ===
          cruds.toUpperCase()
        )
      }
    })
  })
  return foundPermissions
}

const SUBEVENTCRUDS = [
  'EXPORT TO EXCEL',
  'EXPORT TO PDF',
  'EXPORT TO GOOGLE SHEET',
  'EDIT',
  'DUPLICATE',
  'DELETE',
  'CLOSE APPLICATION',
  'SHORTLIST',
  'ADD INTERVIEWERS',
  'BULK ACTION',
  'DOWNLOAD/UPLOAD',
  'INTENT TO OFFER',
  'EXPORT',
  'RATING ALGORITHM',
  'PREVIEW & PUBLISH',
  'SAVE AS DRAFT',
]

export const permittedSubEvents = (permissions, screenName, eventName) =>
  !permissions?.length
    ? SUBEVENTCRUDS
    : SUBEVENTCRUDS?.filter(cruds => {
        return permissions.some(permission => {
          if (
            permission?.subEvents != null &&
            permission?.subEvents?.events?.screens?.screenName?.toLocaleUpperCase() ===
              screenName?.toUpperCase() &&
            permission?.subEvents?.events?.eventName?.toLocaleUpperCase() ===
              eventName?.toUpperCase()
          ) {
            return (
              permission?.subEvents?.subEventName?.toLocaleUpperCase() ===
              cruds.toUpperCase()
            )
          }
        })
      })
export const permittedSubEventCruds = (permissions, screenName) => {
  const foundPermissions = permissions?.filter(permission => {
    return SUBEVENTCRUDS?.find(cruds => {
      if (
        permission?.screens?.screenName?.toLocaleUpperCase() ===
        screenName?.toUpperCase()
      ) {
        return (
          permission?.subEvents?.subEventName?.toLocaleUpperCase() ===
          cruds.toUpperCase()
        )
      }
    })
  })
  return foundPermissions
}

export const PermittedNavRoutes = (permissions, navItems) =>
  !permissions?.length
    ? navItems
    : navItems?.filter(oldData => {
        return permissions?.find(newData => {
          if (newData?.screens != null) {
            return (
              newData?.screens?.screenName?.toLocaleUpperCase() ===
                oldData?.navTitle?.toUpperCase() ||
              oldData?.navTitle === 'Dashboard' ||
              oldData?.navTitle === 'Global' ||
              oldData?.navTitle === 'Mandates' ||
              oldData?.navTitle === 'Corporate Dashboard' ||
              oldData?.navTitle === 'Corporate Dashboard 2' ||
              !oldData?.navTitle
            )
          }
        })
      })
